<template>
  <div :class="_.steps">
    <div
      v-for="(item, index) in list"
      :key="item"
      :class="[
        _.item,
        currentIndex === index
          ? _.current
          : index < currentIndex
          ? _.finished
          : _.pending,
      ]"
    >
      <div :class="_.icon" />
      <div :class="_.label">
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      list: {
        type: Array,
        required: true,
      },
      current: {
        type: String,
        required: true,
      },
    },

    computed: {
      currentIndex() {
        return this.list.indexOf(this.current)
      },
    },
  })
</script>

<style lang="scss" module>
  .steps {
    display: flex;
    justify-content: space-between;

    .item {
      flex: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      .icon {
        width: 10px;
        height: 10px;
        box-sizing: border-box;
        border-radius: 50%;
      }

      .label {
        margin-top: 12px;
        font-size: 12px;
      }

      &::before {
        content: '';
        position: absolute;
        top: 4px;
        right: calc(50% + 5px + 4px);
        left: 0;
        height: 1px;
        border-bottom: 1px solid #dcdcdc;
      }

      &::after {
        content: '';
        position: absolute;
        top: 4px;
        left: calc(50% + 5px + 4px);
        right: 0;
        height: 1px;
        border-bottom: 1px solid #dcdcdc;
      }

      &:first-child {
        &::before {
          display: none;
        }
      }

      &:last-child {
        &::after {
          display: none;
        }
      }

      &.pending {
        .icon {
          background-color: #dcdcdc;
        }

        .label {
          color: #888888;
        }
      }

      &.finished {
        .icon {
          border: 1px solid #ff111c;
        }

        .label {
          color: #222222;
        }

        &::after,
        & + *::before {
          border-bottom-color: #ff1826;
        }
      }

      &.current {
        .icon {
          background-color: #ff1826;
        }

        .label {
          color: #ff1826;
        }
      }
    }
  }
</style>
